import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  FaArrowRight,
  FaCheckCircle,
  FaBullseye,
  FaEye,
  FaAward,
  FaBuilding,
  FaTools,
  FaShieldAlt,
  FaLayerGroup,
  FaUsers,
} from "react-icons/fa";

import cas1 from "../../assets/casorol/c1.webp";
import cas2 from "../../assets/casorol/c2.webp";
import cas3 from "../../assets/casorol/c3.webp";
import cas4 from "../../assets/casorol/c4.jpg";
// import cas5 from "../../assets/casorol/c5.jpg";
// import cas6 from "../../assets/casorol/c6.jpg";
// import cas7 from "../../assets/casorol/c7.jpg";
// import cas8 from "../../assets/casorol/c8.jpg";
// import cas9 from "../../assets/casorol/c9.jpg";
// import cas10 from "../../assets/casorol/c10.jpg";

import aboutVideo from "../../assets/videos/aboutVideo.mp4";
import "./AboutPage.css";

const AboutPage = () => {
  /* =====================================================
     ABOUT HERO CAROUSEL
  ===================================================== */

  const heroSlides = [
    {
      image: cas1,
      title: (
        <>
          Building Sports Spaces
          <span> Built to Perform.</span>
        </>
      ),
      description:
        "We design, construct and transform sports facilities into high-performance spaces built for athletes, institutions and communities across India.",
    },

    {
      image: cas2,
      title: (
        <>
          Surfaces Designed
          <span> For Performance.</span>
        </>
      ),
      description:
        "Premium sports surfaces engineered for performance, durability, safety and long-term value.",
    },

    {
      image: cas3,
      title: (
        <>
          Creating Places
          <span> Where Sport Happens.</span>
        </>
      ),
      description:
        "From schools and academies to professional facilities, we build sporting environments made to perform.",
    },

    {
      image: cas4,
      title: (
        <>
          Built With Quality.
          <span> Built To Last.</span>
        </>
      ),
      description:
        "Complete sports infrastructure solutions from construction and installation to resurfacing and maintenance.",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  /* =====================================================
     AUTOMATIC SLIDE
  ===================================================== */

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => {
        return (prevSlide + 1) % heroSlides.length;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [heroSlides.length]);

  /* =====================================================
     MANUAL SLIDE CONTROLS
  ===================================================== */

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => {
      return (prevSlide + 1) % heroSlides.length;
    });
  };

  const previousSlide = () => {
    setCurrentSlide((prevSlide) => {
      return (prevSlide - 1 + heroSlides.length) % heroSlides.length;
    });
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <main className="about-page">
      {/* =====================================================
          ABOUT HERO CAROUSEL
      ===================================================== */}

      <section className="about-page-hero about-hero-carousel">
        {/* =================================================
            CAROUSEL BACKGROUND SLIDES
        ================================================= */}

        <div className="about-carousel-slides">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`about-carousel-slide ${
                index === currentSlide ? "active" : ""
              }`}
              style={{
                backgroundImage: `url("${slide.image}")`,
              }}
            ></div>
          ))}
        </div>

        {/* =================================================
            DARK OVERLAY
        ================================================= */}

        <div className="about-page-hero-overlay"></div>

        {/* =================================================
            HERO CONTENT
        ================================================= */}

        <div className="about-page-hero-content">
          <span className="about-page-tag">QUALITY SPORTS SURFACE</span>

          <h1 key={`title-${currentSlide}`}>
            {heroSlides[currentSlide].title}
          </h1>

          <p key={`description-${currentSlide}`}>
            {heroSlides[currentSlide].description}
          </p>

          <div className="about-breadcrumb">
            <Link to="/">Home</Link>

            <span>/</span>

            <strong>About Us</strong>
          </div>
        </div>

        {/* =================================================
            PREVIOUS BUTTON
        ================================================= */}

        <button
          type="button"
          className="about-carousel-arrow about-carousel-prev"
          onClick={previousSlide}
          aria-label="Previous slide"
        >
          ‹
        </button>

        {/* =================================================
            NEXT BUTTON
        ================================================= */}

        <button
          type="button"
          className="about-carousel-arrow about-carousel-next"
          onClick={nextSlide}
          aria-label="Next slide"
        >
          ›
        </button>

        {/* =================================================
            SLIDE DOTS
        ================================================= */}

        <div className="about-carousel-dots">
          {heroSlides.map((_, index) => (
            <button
              type="button"
              key={index}
              className={index === currentSlide ? "active" : ""}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </section>

      {/* =====================================================
          WHO WE ARE
      ===================================================== */}

      <section className="about-who-section">
        <div className="about-page-container">
          <div className="about-who-content">
            <span className="about-section-label">WHO WE ARE</span>

            <h2>
              More Than a Surface.
              <span> We Build the Place Where Sport Happens.</span>
            </h2>

            <div className="about-heading-line"></div>

            <p>
              Quality Sports Surface is a sports infrastructure company
              specializing in the design, construction, resurfacing and
              maintenance of professional sports facilities.
            </p>

            <p>
              From schools and universities to sports academies, clubs,
              government organizations and commercial developments, we create
              sports environments designed around performance, durability,
              safety and long-term value.
            </p>

            <p>
              Our approach combines quality materials, experienced workmanship
              and careful project execution to deliver surfaces and facilities
              that are built to perform season after season.
            </p>

            <div className="about-check-list">
              <div>
                <FaCheckCircle />
                <span>Professional Sports Infrastructure</span>
              </div>

              <div>
                <FaCheckCircle />
                <span>Premium Surface Systems</span>
              </div>

              <div>
                <FaCheckCircle />
                <span>Complete Project Execution</span>
              </div>

              <div>
                <FaCheckCircle />
                <span>Long-Term Surface Performance</span>
              </div>
            </div>
          </div>

          <div className="about-who-image">
            <video
              src={aboutVideo}
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />

            <div className="about-image-badge">
              <strong>15+</strong>
              <span>Years of Excellence</span>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          OUR EXPERTISE
      ===================================================== */}

      <section className="about-expertise-section">
        <div className="about-page-container">
          <div className="about-centered-heading">
            <span className="about-section-label">OUR EXPERTISE</span>

            <h2>
              Complete Sports Infrastructure
              <span> Under One Roof</span>
            </h2>

            <p>
              From the foundation to the final playing surface, our expertise
              covers the complete sports facility development process.
            </p>
          </div>

          <div className="expertise-grid">
            <div className="expertise-card">
              <div className="expertise-icon">
                <FaBuilding />
              </div>

              <h3>Sports Courts</h3>

              <p>
                Basketball, tennis, badminton, volleyball, pickleball, paddle
                and squash courts designed for performance and durability.
              </p>
            </div>

            <div className="expertise-card">
              <div className="expertise-icon">
                <FaLayerGroup />
              </div>

              <h3>Sports Flooring</h3>

              <p>
                Acrylic, PU, EPDM and other specialized sports flooring systems
                for different performance requirements.
              </p>
            </div>

            <div className="expertise-card">
              <div className="expertise-icon">
                <FaTools />
              </div>

              <h3>Construction</h3>

              <p>
                Complete construction and development of sports facilities from
                preparation through final installation.
              </p>
            </div>

            <div className="expertise-card">
              <div className="expertise-icon">
                <FaAward />
              </div>

              <h3>Resurfacing</h3>

              <p>
                Professional resurfacing and renovation solutions that restore
                existing sports facilities and extend their life.
              </p>
            </div>

            <div className="expertise-card">
              <div className="expertise-icon">
                <FaShieldAlt />
              </div>

              <h3>Safety & Quality</h3>

              <p>
                Surface systems and construction practices focused on athlete
                safety, consistency and long-term reliability.
              </p>
            </div>

            <div className="expertise-card">
              <div className="expertise-icon">
                <FaUsers />
              </div>

              <h3>Project Support</h3>

              <p>
                Professional guidance throughout planning, construction,
                installation and maintenance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          MISSION / VISION
      ===================================================== */}

      <section className="mission-section">
        <div className="about-page-container">
          <div className="mission-card mission-card-blue">
            <div className="mission-icon">
              <FaBullseye />
            </div>

            <span>OUR MISSION</span>

            <h2>Create Better Places to Play.</h2>

            <p>
              Our mission is to create high-quality sports environments that
              encourage participation, improve performance and provide athletes
              with safe and dependable places to play.
            </p>
          </div>

          <div className="mission-card mission-card-dark">
            <div className="mission-icon">
              <FaEye />
            </div>

            <span>OUR VISION</span>

            <h2>Raise the Standard of Sports Infrastructure.</h2>

            <p>
              We aim to contribute to the development of world-class sports
              infrastructure across India through better design, quality
              materials, skilled execution and continuous innovation.
            </p>
          </div>
        </div>
      </section>

      {/* =====================================================
          WHY QUALITY SPORTS SURFACE
      ===================================================== */}

      <section className="about-why-section">
        <div className="about-page-container">
          <div className="about-centered-heading">
            <span className="about-section-label">
              WHY QUALITY SPORTS SURFACE
            </span>

            <h2>
              Built Around
              <span> Quality, Performance & Trust</span>
            </h2>
          </div>

          <div className="why-grid">
            <div className="why-item">
              <span className="why-number">01</span>

              <div>
                <h3>Quality Materials</h3>

                <p>
                  We focus on selecting surface systems and materials suited to
                  the requirements of each sports facility.
                </p>
              </div>
            </div>

            <div className="why-item">
              <span className="why-number">02</span>

              <div>
                <h3>Experienced Execution</h3>

                <p>
                  Every project requires careful preparation, installation and
                  finishing. Our approach focuses on getting the details right.
                </p>
              </div>
            </div>

            <div className="why-item">
              <span className="why-number">03</span>

              <div>
                <h3>Performance Focused</h3>

                <p>
                  Sports surfaces are designed with playability, durability,
                  athlete comfort and long-term performance in mind.
                </p>
              </div>
            </div>

            <div className="why-item">
              <span className="why-number">04</span>

              <div>
                <h3>Complete Solutions</h3>

                <p>
                  From sports courts and running tracks to synthetic turf and
                  flooring systems, we offer solutions across multiple sports.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          SPORTS WE BUILD
      ===================================================== */}

      <section className="about-sports-section">
        <div className="about-page-container">
          <div className="sports-content">
            <span className="about-section-label">SPORTS INFRASTRUCTURE</span>

            <h2>
              Spaces Designed for
              <span> Every Kind of Game.</span>
            </h2>

            <p>
              Our expertise extends across a wide range of sporting
              environments, allowing us to create facilities for schools,
              academies, institutions, clubs and professional sporting
              organizations.
            </p>
          </div>

          <div className="sports-list">
            <div>
              <FaCheckCircle />
              Basketball Courts
            </div>

            <div>
              <FaCheckCircle />
              Tennis Courts
            </div>

            <div>
              <FaCheckCircle />
              Football Fields
            </div>

            <div>
              <FaCheckCircle />
              Running Tracks
            </div>

            <div>
              <FaCheckCircle />
              Badminton Courts
            </div>

            <div>
              <FaCheckCircle />
              Pickleball Courts
            </div>

            <div>
              <FaCheckCircle />
              Paddle Courts
            </div>

            <div>
              <FaCheckCircle />
              Squash Courts
            </div>

            <div>
              <FaCheckCircle />
              Synthetic Turf
            </div>

            <div>
              <FaCheckCircle />
              EPDM Flooring
            </div>

            <div>
              <FaCheckCircle />
              PU Flooring
            </div>

            <div>
              <FaCheckCircle />
              Multi-Sport Facilities
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="about-page-cta">
        <div className="about-page-cta-content">
          <span>READY TO BUILD YOUR SPORTS FACILITY?</span>

          <h2>
            Let's Build Something
            <strong> Exceptional Together.</strong>
          </h2>

          <p>
            Tell us about your sports infrastructure project and our team will
            help you find the right solution.
          </p>

          <Link to="/contact" className="about-cta-button">
            Get a Free Consultation
            <FaArrowRight />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
